import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KpiKeys, Segment } from '@models';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'ai-summary',
  templateUrl: './ai-summary.component.html',
  styleUrl: './ai-summary.component.scss'
})
export class AiSummaryComponent {
  @Input() summaryTitle = 'Study summary';
  @Input() summary: Observable<string | Segment[]> = of('Loading...');

  @Output() kpiClicked = new EventEmitter<KpiKeys>();

  onSegmentClicked(segment: Segment): void {
    if (segment.metadata) {
      const selectedKpi = segment.metadata['id'] as KpiKeys;
      this.kpiClicked.emit(selectedKpi);
    }
  }

  getSegments(summary: string | Segment[]): Segment[] | undefined {
    return typeof summary === 'string' ? undefined : summary;
  }

  getSummaryText(summary: string | Segment[]): string | undefined {
    return typeof summary === 'string' ? summary : undefined;
  }
}
